module.exports = __webpack_public_path__ + "img/Sevilla.33307966.png";